import AxL from "./axl";
export default class Tracking {
  constructor(axl) {
    this.axl = axl;
    this.trackingEvents = {
      ui_click: { eventName: "toogle_ui_tools", NI: false, value: 0 },
      switch: { eventName: "switch_change", NI: false, value: 0 },
      share_screen: { eventName: "shared_screen_open", NI: true, value: 0 },
      asset_screen: { eventName: "open_asset_view", NI: false, value: 0 },
      navigate: { eventName: "navigate_to_asset", NI: false, value: 0 },
      //   download: { eventName: "download_b64_image", NI: false, value: 0 },
      intro_complete: { eventName: "intro_complete", NI: true, value: 0 },
      skip_intro: { eventName: "skip_intro", NI: false, value: 0 },
      colorize: {
        eventName: "image_send_to_colorization",
        NI: false,
        value: 0,
      },
    };
  }
  track(event, value = null) {
    if (this.axl) {
      const param = {
        action: this.trackingEvents[event].eventName,
        value: this.trackingEvents[event].value,
        nonInteraction: this.trackingEvents[event].NI,
      };
      if (value) param["label"] = value;
      this.axl.sendMessage(AxL.ChildToHost.TRACK, param);
    } else {
      console.log("AXL IS NOT AVAILABLE FOR TRACKING");
    }
  }
}
